import React, { PropsWithChildren } from 'react';
import { makeStyles } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import CategoryIcon from '@material-ui/icons/Category';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import CreateComponentIcon from '@material-ui/icons/AddCircleOutline';
import SearchIcon from '@material-ui/icons/Search';
import SettingsIcon from '@material-ui/icons/Settings';
import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarPage,
  SidebarSpace,
} from '@backstage/core-components';

const useStyles = makeStyles({
  '@global': {
    '*, *::before, *::after': {
      boxSizing: 'border-box',
    },
  },
});

export const Root = ({ children }: PropsWithChildren<{}>) => {
  useStyles();
  return (
    <SidebarPage>
      <Sidebar>
        <SidebarGroup label="Menu" icon={<HomeIcon />}>
          <SidebarItem icon={CategoryIcon} to="/catalog" text="Catalog" />
          <SidebarItem icon={LibraryBooksIcon} to="/docs" text="TechDocs" />
          <SidebarItem
            icon={CreateComponentIcon}
            to="/create"
            text="Create..."
          />
          <SidebarDivider />
          <SidebarItem icon={SearchIcon} to="/search" text="Search" />
        </SidebarGroup>
        <SidebarSpace />
        <SidebarDivider />
        <SidebarGroup label="Settings" icon={<SettingsIcon />}>
          <SidebarItem icon={SettingsIcon} to="/settings" text="Settings" />
        </SidebarGroup>
      </Sidebar>
      {children}
    </SidebarPage>
  );
};
